import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';

@Component({
  selector: 'app-vis-graph-page',
  templateUrl: './vis-graph-page.component.html',
  styleUrls: ['./vis-graph-page.component.scss']
})
export class VisGraphPageComponent implements OnInit, AfterViewInit {
  @ViewChild('element', {static: true, read: ElementRef}) element: ElementRef;

  constructor() { }

  ngOnInit(): void {
  }


  ngAfterViewInit() {
    const allScripts = Array.from(document.querySelectorAll('script'));
    let wcScript = allScripts.find((script) => script.src.includes('flowvisgraph'));
    if (!wcScript) {
      const script = document.createElement('script');
      script.src = 'assets/flowvisgraph/index.js';
      script.type = 'module';
      document.head.appendChild(script);
      wcScript = script;
    }
    this.waitForShadowDOM(this.element.nativeElement, () => {
      const linkElm = document.createElement('link');
      linkElm.rel = 'stylesheet';
      linkElm.href = 'assets/flowvisgraph/index.css';
      const shadowRoot = this.element.nativeElement.shadowRoot;
      shadowRoot.appendChild(linkElm);
    });
  }



  private waitForShadowDOM(el: HTMLElement, callback: () => void) {
    const checkInterval = setInterval(() => {
      if (el.shadowRoot) {
        callback();
        clearInterval(checkInterval);  // Important: Clear the interval once the shadowRoot is available
      }
    }, 100);  // Check every 100ms. Adjust as needed.
  }
}
